import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogTitle, LinearProgress } from "@mui/material";
import DeleteDialogStyle from "styles/application/DeleteDialogStyle";

const ADD = DeleteDialogStyle();

const DeleteDialog = ({
	confirmDelete,
	closeHandler,
	handleDeleteConfirm,
	isUpdating,
}) => {
	const { t } = useTranslation();
	return (
		<Dialog
			open={confirmDelete}
			onClose={closeHandler}
			aria-labelledby="delete-title"
			aria-describedby="delete-description"
		>
			{isUpdating ? <LinearProgress /> : null}

			<ADD.ActionContainer>
				<DialogTitle id="delete-dialog-title">
					{<ADD.HeaderText>{t("message.areYouSure")}</ADD.HeaderText>}
				</DialogTitle>
				<ADD.ButtonContainer>
					<ADD.CancelButton onClick={closeHandler} variant="contained">
						{t("action.cancel")}
					</ADD.CancelButton>
					<ADD.DeleteButton
						onClick={() => handleDeleteConfirm(null)}
						variant="contained"
					>
						{t("action.delete")}
					</ADD.DeleteButton>
				</ADD.ButtonContainer>
			</ADD.ActionContainer>
		</Dialog>
	);
};

export default DeleteDialog;
